var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-component',{attrs:{"value":_vm.value,"options":_vm.historyModalOptions,"scrollable":""},on:{"ok":_vm.closeModal,"cancel":_vm.closeModal}},[_c('employee-history',{attrs:{"employeeId":_vm.employeeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }